import { FC, ReactElement, useEffect } from "react";
import { Alert } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { usePlant } from "../../components/PlantHook";
import { clearAlertAction, resetImportStateAction } from "../redux/ProductCapabilitiesActions";
import { ProductCapabilitiesExportSection } from "./ProductCapabilitiesExportSection";
import { ProductCapabilitiesImportSection } from "./ProductCapabilitiesImportSection";

export const ProductCapabilitiesPage: FC<{ props: any }> = ({ props }): ReactElement => {
  const plantCode = usePlant();
  const dispatch = useDispatch();

  const { alert } = useSelector(
    (state: any) => ({ alert: state.productCapabilities.alert }),
    shallowEqual
  );

  // Switching plants must not leak the previous plant's import result/errors into the new view.
  useEffect(() => {
    dispatch(resetImportStateAction());
  }, [dispatch, plantCode]);

  return (
    <Card {...props}>
      <CardHeader title={`Product Capabilities — ${plantCode}`} {...props} />
      <CardBody {...props}>
        {alert && (
          <Alert
            variant={alert.type === "success" ? "success" : "danger"}
            onClose={() => dispatch(clearAlertAction())}
            dismissible
            data-testid="product-capabilities-alert"
          >
            {alert.message}
          </Alert>
        )}
        <div className="row">
          <div className="col-md-6">
            <ProductCapabilitiesExportSection plantCode={plantCode} />
          </div>
          <div className="col-md-6">
            <ProductCapabilitiesImportSection plantCode={plantCode} />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default ProductCapabilitiesPage;
